import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedPercentage from 'I18n/components/FormattedPercentage';
import { RightIcon } from 'foundations-assets';
import { Flex } from 'foundations-components/components/Flex';
import { Progress } from 'foundations-components/transitional/components/Progress';
import { View } from 'foundations-components/components/View';
import { Text } from 'foundations-components/components/Text';
import { Button } from 'foundations-components/transitional/components/Button';
import { useTaskGroupProgress, useTaskDataByGroupKey, useTaskGroupCta } from '../../../hooks/task';
import { useTracker } from '../../../hooks/tracking';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TaskGroupProgress = ({
  groupKey,
  isTaskGroupCompleted,
  onGroupClick
}) => {
  const taskGroupData = useTaskDataByGroupKey(groupKey);
  const {
    remainingDuration,
    percentageComplete
  } = useTaskGroupProgress(taskGroupData);
  const {
    trackUserInteraction
  } = useTracker();
  const taskGroupCta = useTaskGroupCta(groupKey);
  if (taskGroupCta) {
    return /*#__PURE__*/_jsxs(Button, {
      "data-test-id": `start-tasks-link-${groupKey}`,
      onClick: () => {
        if (onGroupClick) {
          onGroupClick(groupKey);
        }
        trackUserInteraction('click start tasks', groupKey);
      },
      use: "primary",
      children: [taskGroupCta, /*#__PURE__*/_jsx(RightIcon, {})]
    });
  }
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "end",
    blockSize: "100%",
    columnGap: "100",
    flexDirection: "column",
    children: [/*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      children: [/*#__PURE__*/_jsx(Progress, {
        "aria-label": I18n.text('setup-guide-components.consolidatedUserGuide.taskViewCard.progressLabel', {
          percentageCompleted: /*#__PURE__*/_jsx(FormattedPercentage, {
            value: percentageComplete
          })
        }),
        blockSize: "6px",
        hasLabel: false,
        inlineSize: "85px",
        margin: "0",
        value: percentageComplete
      }), /*#__PURE__*/_jsx(Text, {
        as: "small",
        marginInlineStart: "200",
        children: /*#__PURE__*/_jsx(FormattedPercentage, {
          value: percentageComplete
        })
      })]
    }), /*#__PURE__*/_jsx(View, {
      children: /*#__PURE__*/_jsx(Text, {
        as: "small",
        color: isTaskGroupCompleted ? 'text-positive-default' : 'text-core-subtle',
        children: isTaskGroupCompleted ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: "setup-guide-components.consolidatedUserGuide.taskViewCard.greatJob"
        }) : percentageComplete === 0 ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: "setup-guide-components.consolidatedUserGuide.taskViewCard.duration",
          options: {
            minutes: remainingDuration
          }
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: "setup-guide-components.consolidatedUserGuide.taskViewCard.timeLeft",
          options: {
            minutes: remainingDuration
          }
        })
      })
    })]
  });
};
export default TaskGroupProgress;